import { CleaningZoneApi } from "../cleaning-zone";

interface TeachingUpdateMessage {
  roomId: string;
  zoneId: string;
  type: TeachingUpdateType;
  messageCodes: string[];
  path: number[][];
  zone: CleaningZoneApi | null;
}

export enum TeachingUpdateType {
  StartTeachingSuccess = "StartTeachingSuccess",
  StartTeachingError = "StartTeachingError",
  SetStartPositionSuccess = "SetStartPositionSuccess",
  SetStartPositionError = "SetStartPositionError",
  SaveAndEndTeachingSuccess = "SaveAndEndTeachingSuccess",
  SaveAndEndTeachingError = "SaveAndEndTeachingError",
  AbortTeachingSuccess = "AbortTeachingSuccess",
  AbortTeachingError = "AbortTeachingError",
  TeachingUpdate = "TeachingUpdate",
  TeachingError = "TeachingError",
  AutoGeneratePathSuccess = "AutoGeneratePathSuccess",
  AutoGeneratePathError = "AutoGeneratePathError",
}

export const isTeachingUpdateMessage = (input: any): input is TeachingUpdateMessage => {
  return "path" in input && "messageCodes" in input && "roomId" in input && "zoneId" in input && "type" in input;
};

export default TeachingUpdateMessage;
